import { ReactElement, useReducer } from 'react';
import { HeaderText } from '@components/Text';
import { FullBleedPadding } from '@components/ContentPadding';
import clsx from 'clsx';
import Plus from '../icon/plus.svg';
import { GetHowItWorksPageQuery } from 'generated/graphql';
import { MarkdownText } from './MarkdownText';

export default function FrequentlyAskedQuestions({
  faq,
}: {
  faq: GetHowItWorksPageQuery['howItWorks']['faqCollection']['items'];
}): ReactElement {
  return faq.length > 0 ? (
    <>
      <FullBleedPadding>
        <HeaderText as="h2" className="mb-5">
          F.A.Q.
        </HeaderText>
      </FullBleedPadding>
      {faq.map(({ question, answer }, index) => (
        <FrequentAskedRow
          key={index}
          className={index === faq.length - 1 ? 'border-b-2' : ''}
          question={question}
          answer={answer}
        />
      ))}
    </>
  ) : null;
}

const FrequentAskedRow = ({
  question,
  answer,
  className,
}: {
  question: string;
  answer: string;
  className?: string;
}) => {
  const [isOpen, toggle] = useReducer((state) => !state, false);
  return (
    <button
      className={clsx(
        'flex flex-col w-full border-black border-t-2',
        className
      )}
      onClick={toggle}
    >
      <FullBleedPadding className="flex justify-between items-center py-3">
        <div className="font-semibold">{question}</div>
        <Plus />
      </FullBleedPadding>
      <FullBleedPadding>
        {isOpen && (
          <p className="w-1/2 text-left mb-4">
            <MarkdownText text={answer} />
          </p>
        )}
      </FullBleedPadding>
    </button>
  );
};
